import Link from 'next/link'
// Components
import rootStyles from '../../pages/puppy/[id].module.scss'
import styles from './Breeder.module.scss'
import Title from '../Title'
import TextBody from '../TextBody/TextBody'

export default function Breeder ({ dog, isMobile }) {
  const breeder = dog?.breeder

  return (
    <div className={rootStyles.section}>
      <Title variant='h2'>Responsible Breeder</Title>

      <TextBody className={styles.name}>
        <span className={styles.name}>{dog?.name}</span>'s breeder is approved
        by our health, safety, and socialization standards.
      </TextBody>

      <div className={styles.certification}>
        <div className={styles.badge}>
          <Link href={`/breeder/${breeder?.id}`} legacyBehavior>
            <img
              width='70px'
              height='70px'
              alt='badge on'
              src={
                breeder?.profilePicture?.medium
                  ? `${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${breeder?.profilePicture?.medium}`
                  : '/badge-on.svg'
              }
            />
          </Link>
        </div>

        <div className={styles.content}>
          <p className={rootStyles.subtitle}>Mawoo Verified Breeder</p>

          {!!breeder?.yearsOfExperience && (
            <p className={styles.text}>
              {`Member for ${breeder?.yearsOfExperience} Years`}
            </p>
          )}

          <div className={styles.location}>
            <img
              src='/pin-green.svg'
              alt='location icon'
              className={styles.marker}
            />

            <p className={styles.text}>
              {breeder?.city}, {breeder?.state}
            </p>
          </div>
        </div>

        <Link href={`/breeder/${breeder?.id}`} className={styles.action}>
          {!isMobile ? <p>View Profile</p> : null}
          <img
            src='/puppy/arrow-right-black2.svg'
            alt='View Breeder Profile'
            width='8px'
            height='12px'
          />
        </Link>
      </div>
    </div>
  )
}
